import React, { useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import "./AddPrimaryThemes.css";
import save from "../../../assets/images/save.svg";
import cancel from "../../../assets/images/cancel.svg";
import InputLayout from "../../../components/uikit/components/inputLayout/InputLayout";

const AddPrimaryThemeForm = ({ onSave, onClose }) => {
  const [primaryTheme, setPrimaryTheme] = useState("");
  const [focus, setFocus] = useState("");

  const handleSave = () => {
    if (!primaryTheme || !focus) return; // Prevent saving empty values
    onSave(primaryTheme, focus);
    setPrimaryTheme(""); // Reset input fields
    setFocus("");
  };


  return (
    <div className="primary-theme-container">
      <div className="primary-theme-header">
        <div className="primary-theme-header-heading">Add Primary Theme</div>
        <div className="primary-actions">
          <div className="save-prompt-add" onClick={onClose}>
            <button className="">
              <img
                src={cancel}
                alt="cancel"
                style={{ width: "11px", height: "11px" }}
              />
            </button>
          </div>
          <div className="save-prompt-add">
            <button className="" onClick={handleSave}>
              <img
                src={save}
                alt="save"
                style={{ width: "14px", height: "14px" }}
              />
            </button>
          </div>
        </div>
      </div>

      <div className="primary-input-group">
        <div className="input-field">
          <label>Primary Theme</label>
          {/* <input
            className="add-theme-input"
            type="text"
            value={primaryTheme}
            onChange={(e) => setPrimaryTheme(e.target.value)}
            placeholder="Enter theme"
          /> */}
          <InputLayout
            placeholder="Enter theme"
            className="add-theme-input"
            onChange={(e) => setPrimaryTheme(e.target.value)}
            value={primaryTheme}
            type="text"
          />
        </div>

        <div className="focus-input-field">
          <label>Focus</label>
          <InputLayout
            placeholder="Enter focus"
            className="add-focus-input"
            onChange={(e) => setFocus(e.target.value)}
            value={focus}
            type="text"
          />
        </div>
      </div>
    </div>
  );
};

export default AddPrimaryThemeForm;
